import { Timeline as AntTimeline } from 'antd'
import styled from 'styled-components'
import Text from 'antd/lib/typography/Text'

export const Timeline = styled(AntTimeline)`
  max-height: 60vh;
  min-height: 30vh;
  overflow: scroll;
  overflow-x: hidden;
  padding: 1rem;
`

export const Occurrence = styled(Text)`
  font-size: large;
`

export const Justification = styled(Text)`
  font-size: smaller;
`
